import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import './styles.css';
import numeral from 'numeral';

class Label extends Component {
	render() {
		const { children } = this.props;
		return <span>{children}</span>;
	}
}

Label.propTypes = {
	children: PropTypes.node.isRequired
};

const HeartsAndMoney = ({ game }) => 
	<div className="hearts-and-money">
		<Icon icon="heart" />
		<Label>{game.hearts}</Label>
		<Icon icon="money" />
		<Label>{numeral(game.money).format('0,0')}</Label>
	</div>
;

HeartsAndMoney.propTypes = {
	game: PropTypes.shape({
		hearts: PropTypes.number.isRequired,
		money: PropTypes.number.isRequired
	})
};

export default HeartsAndMoney;
